export const PHONE_REGEX = /^(\+)?([ 0-9]){10,16}$/;
export const PHONE_SANDBOX_REGEX = /^(\+)?([ 0-9]){10,16}#[a-z0-9_]+$/;
